document.addEventListener('DOMContentLoaded', function () {
  function initBASwipers() {
    if (typeof Swiper === 'undefined') {
      setTimeout(initBASwipers, 100);
      return;
    }

    document.querySelectorAll('.ba-swiper').forEach(function (swiperEl) {
      const section = swiperEl.closest('.ba-section');

      new Swiper(swiperEl, {
        slidesPerView: 1.1,
        spaceBetween: 16,
        grabCursor: true,

        navigation: {
          prevEl: section ? section.querySelector('.ba-btn-prev') : null,
          nextEl: section ? section.querySelector('.ba-btn-next') : null,
        },

        pagination: {
          el: section ? section.querySelector('.swiper-pagination') : null,
          type: 'progressbar'
        },

        breakpoints: {
          480:  { slidesPerView: 2,  spaceBetween: 16 },
          768:  { slidesPerView: 2.5,  spaceBetween: 18 },
          1024: { slidesPerView: 2.5,  spaceBetween: 10 },
          1200: { slidesPerView: 3.3,    spaceBetween: 10 }
        }
      });
    });
  }
initBASwipers();

});